<template>
  <div class="share">
    <img :src="banner" alt="" class="banner">
    <div class="infos">
      <div class="info">
        <img :src="img" alt="" class="img">
        <div class="name">{{ name }}</div>
      </div>
      <div class="texts">
        <div class="text">2024新歌来啦全国海选</div>
        <div class="text" v-if="isok != 1">请帮助您的好友实现音乐梦想</div>
      </div>
    </div>
    <div class="content">
      <div class="title" v-if="isok == 1">已有{{ topnum1 }}位好友为你成功助力</div>
      <div class="title" v-else>已获得{{ topnum1 }}位好友支持</div>
      <div class="xnum" v-if="xnum < 100">已获取{{xnum}}星热度值·还差{{0 > (100 - xnum) ? 0 : (100 - xnum)}}星热度值</div>
      <div class="xnum" v-else>已获取{{xnum}}星热度值</div>
      <div class="lines">
        <div class="line" :style="{'width': topnum > 100 ? 100 : topnum + '%'}"></div>
        <div class="nums" :style="{'left': topnum > 100 ? 100 : topnum + '%'}">
          <div class="spot"></div>
          <div class="num" :class="{'left': topnum > 90}">{{ topnum }}%</div>
        </div>
      </div>
      <div class="btn purple" v-if="isok == 1" @click="shareModal = true">转发分享此页面获取星热度值</div>
      <div class="btns" v-else>
        <div class="btn" @click="submit()">
          <img src="../assets/img/btn_bg_1.png" alt="" class="img">
        </div>
        <div class="btn" @click="goHome()">
          <img src="../assets/img/btn_bg_2.png" alt="" class="img">
        </div>
      </div>
    </div>
    <div class="lists_wrap">
      <div class="title">支持好友列表</div>
      <div class="lists">
        <div class="list" v-for="(item, index) in lists" :key="index">
          <img :src="item.logo" alt="" class="img">
          <div class="name ellipsis">{{ item.name }}</div>
        </div>
      </div>
      <div class="no_data" v-if="lists.length <= 0">
        <img src="../assets/img/icon_no_data.png" alt="" class="icon">
        <div class="text">暂无好友助力记录</div>
      </div>
    </div>
    <van-popup v-model="shareModal" position="top">
      <div class="share_modal">
        <img src="../assets/img/icon_fenxiang_jiantou.png" alt="" class="icon">
        <div class="text">请点击右上角进行分享！</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk';
export default {
  data() {
    return {
      banner: '',
      img: '',
      name: '',
      xnum: 0,
      topnum: 0, // 百分比
      topnum1: 0, //
      isok: 0,//0 表示不是自己分享的 1 表示是自己分享
      lists: [],
      shareModal: false,
      shareId: '',
    };
  },
  mounted() {
    this.shareId = this.$route.query.shareId;
    if (this.$route.query.uuid) {
      localStorage.setItem('uuid', this.$route.query.uuid);
    }
    this.getBanner();
    this.getShareConfig();
    if (!localStorage.getItem('uuid')) {
      this.wxLogin();
    } else {
      this.getInfo();
    }
  },
  methods: {
    getShareConfig () {
      let link = this.isIos ? this.ios_first_url : location.href.split("#")[0];
      let that = this;
      this.axios.post('/Home/WeAuth/getConfig', {
        url: link
      })
        .then(({data}) => {
          if (data.code === 1) {
            wx.config({
              // debug: true,
              appId: data.data.appId,
              timestamp: data.data.timestamp,
              nonceStr: data.data.nonceStr,
              signature: data.data.signature,
              jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone']
            });
            wx.ready(function() {
              wx.checkJsApi({
                jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
                success: function(res) {
                  let options = {
                    title: '新歌来啦官方通道', // 分享标题
                    desc: '为我的音乐梦想助力加油~', // 分享描述
                    link: location.origin + '/#/share?shareId=' + that.shareId, // 分享链接
                    imgUrl: location.origin + '/logo.png', // 分享图标
                    success: function () {
                    // 用户确认分享后执行的回调函数
                    },
                    cancel: function () {
                    // 用户取消分享后执行的回调函数
                    }
                  }
                  wx.onMenuShareTimeline(options);
                  wx.onMenuShareAppMessage(options);
                  wx.onMenuShareQQ(options);
                  wx.onMenuShareWeibo(options);
                  wx.onMenuShareQZone(options);
                }
              });
            });
          }
        });
    },
    getBanner () {
      this.axios.get('/api/Index/getInfo?type=5')
        .then(({data}) => {
          if (data.code === 200) {
            this.banner = data.data.logo;
          }
        });
    },
    getInfo () {
      this.axios.post('/api/Index/getXingList', {
        shareid: this.shareId,
        uuid: localStorage.getItem('uuid')
      })
        .then(({data}) => {
          if (data.code === 1) {
            this.img = data.data.logo;
            this.name = data.data.name;
            this.xnum = data.data.xnum;
            this.topnum = data.data.topnum;
            this.topnum1 = data.data.topnum1;
            this.isok = data.data.isok;
            this.lists = data.data.list;
            if (data.data.isok != 1) {
              localStorage.setItem('inviteId', this.shareId);
            }
            if (data.isret1 == 1) {
              window.location.replace(data.returl);
            } else {
              if (data.data.isret == 1) {
                this.wxLogin();
              }
            }
          }
        });
    },
    wxLogin () {
      window.location.href = this.base_url + '/Home/WeAuth/index?redirect_uri=' + encodeURIComponent(window.location.href);
    },
    submit () {
      if (!localStorage.getItem('uuid')) {
        this.wxLogin();
      } else {
        this.axios.post('/api/Index/setXing', {
          shareid: this.shareId,
          uuid: localStorage.getItem('uuid')
        })
          .then(({data}) => {
            if (data.code === 9) {
              this.Toast(data.msg);
              setTimeout(() => {
                this.wxLogin();
              }, 1500);
            } else if (data.code == 1) {
              this.getInfo();
            } else {
              this.Toast(data.msg);
            }
          });
      }
    },
    goHome () {
      this.$router.replace('/')
    }
  }
}
</script>

<style lang="scss">
  .share{
    background: url('../assets/img/bg.png') no-repeat 0 0 / 100% 2000px;
    padding: 50px 30px;
    .banner{
      width:100%;
      height:360px;
      border-radius: 28px;
      object-fit: cover;
    }
    .infos{
      background:#fff;
      border-radius: 28px;
      margin-top:40px;
      height:100px;
      display:flex;
      align-items: center;
      justify-content: space-between;
      padding:0 30px 0 50px;
      .info{
        display:flex;
        align-items: center;
        .img{
          width:60px;
          height:60px;
          object-fit: cover;
          border-radius: 50%;
        }
        .name{
          font-size:30px;
          font-weight: bold;
          margin-left:30px;
          letter-spacing: 3px;
        }
      }
      .texts{
        text-align: center;
        .text{
          color:#cccccc;
          font-size:24px;
          line-height:40px;
          letter-spacing: 3px;
        }
      }
    }
    .content{
      background:#fff;
      border-radius: 28px;
      margin-top:40px;
      padding-bottom: 50px;
      .title{
        line-height:60px;
        text-align: center;
        width:470px;
        color:#fff;
        font-size:26px;
        background:#032277;
        border-radius: 0 0 50px 50px;
        margin: 0 auto;
        letter-spacing: 4px;
      }
      .xnum{
        margin-top:60px;
        text-align: center;
        font-size:28px;
        letter-spacing: 4px;
      }
      .lines{
        width:540px;
        height:44px;
        border:2px solid #7e00f0;
        border-radius: 22px;
        margin: 100px auto 0;
        padding: 2px;
        position: relative;
        .line{
          height:100%;
          background: repeating-linear-gradient(135deg, #8400e6, #8400e6 20px, #8d00f2 20px, #8d00f2 40px);
          // background:#7e00f0;
          border-radius: 22px;
        }
      }
      .nums{
        position:absolute;
        top:50%;
        z-index:1;
        margin-left:-34px;
        margin-top:-34px;
        .spot{
          width:68px;
          height:68px;
          border-radius: 50%;
          background:#fff;
          border: 5px solid #7e00f0;
          box-shadow: 0 0 0 16px rgba($color: #7e00f0, $alpha: 0.5);
          // animation: shadow 1.5s linear  infinite;
        }
        // @keyframes shadow {
        //   0% {
        //     box-shadow: 0 0 0 0 rgba($color: #7e00f0, $alpha: 0.5);
        //   }
        //   100% {
        //     box-shadow: 0 0 0 16px rgba($color: #7e00f0, $alpha: 0.5);
        //   }
        // }
        .num{
          font-size:26px;
          color:#001a72;
          font-style: italic;
          position:absolute;
          top:-30px;
          right:-70px;
          font-weight: 600;
          &.left{
            right: 80px;
          }
        }
      }
      .btns{
        display:flex;
        align-items: center;
        justify-content: space-between;
        padding:70px 60px 0;
      }
      .btn{
        width:270px;
        height:70px;
        &.purple{
          margin: 70px auto 0;
          width:540px;
          background:linear-gradient(180deg, #bc70fe, #6904c2);
          text-align: center;
          line-height:70px;
          color:#fff;
          font-size:28px;
          border-radius: 50px;
          letter-spacing: 2px;
        }
      }
    }
    .lists_wrap{
      margin-top:40px;
      background:#fff;
      background:#fff;
      border-radius: 28px;
      padding:40px 20px 0;
      .title{
        font-size:34px;
        color:#032277;
        text-align: center;
        font-weight: 600;
        letter-spacing: 4px;
        margin-bottom:40px;
        position: relative;
        &:after, &:before{
          content:'';
          display:block;
          width:8px;
          height:8px;
          background:#e6e6e6;
          border-radius: 50%;
          position:absolute;
          top:50%;
          margin-top: -4px;
          box-shadow: 0 4px 4px 0 #a0b1bc inset;
        }
        &:after{
          right: 180px;
        }
        &:before{
          left:180px;
        }
      }
      .lists{
        display:flex;
        flex-wrap: wrap;
        max-height:290px;
        overflow-y: scroll;
        .list{
          width:calc(100% / 6);
          text-align: center;
          padding: 20px 5px;
          .img{
            width:60px;
            height:60px;
            border-radius: 50%;
            object-fit: cover;
          }
          .name{
            font-size:24px;
            margin-top:10px;
          }
        }
      }
      .no_data{
        text-align: center;
        padding: 80px 0;
        .icon{
          width:170px;
          height:190px;
        }
        .text{
          margin-top:30px;
          color:#032277;
          font-size:28px;
          letter-spacing: 4px;
        }
      }
    }
    .bm_btn{
      margin: 30px auto 0;
      width:360px;
      height:70px;
      text-align: center;
      line-height:70px;
      color:#fff;
      font-size:30px;
      border-radius: 35px;
      background:linear-gradient(180deg, #bb6ffe, #6905c3);
      letter-spacing: 1px;
    }
    .share_modal{
      width:100%;
      text-align: right;
      .icon{
        width:200px;
      }
      .text{
        font-size:36px;
        color:#fff;
        line-height:50px;
        margin-top:30px;
      }
    }
  }
</style>